import { Component, Input, OnInit, Type } from '@angular/core';
import { ExportConfig, ExportWidgetProvider } from '@shared/services';
import { BaseExportModel } from '@app/export/models';
import { ViewAction, AntViewActionModule } from '@antony/ng-ui';
import { NgIf, NgFor } from '@angular/common';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-export-widget',
  templateUrl: './export-widget.component.html',
  styleUrls: ['./export-widget.component.scss'],
  imports: [NgIf, MatCard, MatCardContent, MatCardTitle, MatIcon, NgFor, AntViewActionModule, MatCheckbox, TranslatePipe],
})
export class ExportWidgetComponent implements OnInit {
  @Input()
  exportService: ExportWidgetProvider<any> | null = null;

  config: ExportConfig | null = null;
  model: BaseExportModel<any> | null = null;
  viewActions: Type<ViewAction>[] | null = null;

  constructor() {}

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    if (!!this.exportService) {
      this.config = this.exportService.getConfig();
      this.model = this.exportService.getData();
      this.viewActions = this.exportService.getViewActions();
    }
  }
}
